import { useParams } from 'react-router-dom'

import { SelectorClassMembershipsDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import { AddParticipantsToClassModal as AddParticipantsToClassModalComponent } from 'modules/trainings/components/Revamp/TrainingsDetail/Classes/ParticipantsTab/AddParticipantsToClassModal'

const AddParticipantsToClassModal = () => {
  const { classId } = useParams()

  const { data, loading } = useQuery(SelectorClassMembershipsDocument, {
    variables: { trainingClassId: String(classId) },
  })

  if (loading) return <Loading />

  const employeeIds = data?.trainings.trainingClassMembershipsConnection.nodes?.map(
    (membership) => membership.access?.employee?.id
  )
  return <AddParticipantsToClassModalComponent employeeIds={compact(employeeIds)} />
}

export default AddParticipantsToClassModal
